// 20 productos: ibéricos + platos al vacío + conservas + bebida
// Precios en céntimos (cents) para evitar floats; unit es la presentación
export const PRODUCTS = [
  // ===== IBÉRICOS =====
  {
    id: "jamon-bellota-100g",
    category: "ibericos",
    name: "Jamón Ibérico de Bellota",
    unit: "Loncheado 100 g",
    description: "Loncheado a cuchillo · curación 36 meses",
    price_cents: 850,
    image:
      "https://customer-assets.emergentagent.com/job_corte-tradicional/artifacts/qhzgpvw1_Raul-y-Isabel.jpg",
  },
  {
    id: "jamon-bellota-500g",
    category: "ibericos",
    name: "Jamón Ibérico de Bellota",
    unit: "Sobre 500 g",
    description: "Pack ahorro · ideal para celebración",
    price_cents: 3600,
    image:
      "https://images.unsplash.com/photo-1612487439139-c2d56e95c89e?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "lomito-bellota-100g",
    category: "ibericos",
    name: "Lomito Ibérico de Bellota",
    unit: "Loncheado 100 g",
    description: "Curación natural · sabor profundo",
    price_cents: 750,
    image:
      "https://images.unsplash.com/photo-1611601679499-5e1fcd9787c8?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "lomo-cana-200g",
    category: "ibericos",
    name: "Lomo de Caña Ibérico",
    unit: "Pieza 200 g",
    description: "Embuchado tradicional con pimentón",
    price_cents: 1200,
    image:
      "https://images.unsplash.com/photo-1599050751795-1b3f0a64c20c?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "chorizo-iberico",
    category: "ibericos",
    name: "Chorizo Ibérico de Bellota",
    unit: "Sarta 250 g",
    description: "Curación lenta · pimentón de la Vera",
    price_cents: 900,
    image:
      "https://images.unsplash.com/photo-1626200937472-3c4f06c8f4bc?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "salchichon-iberico",
    category: "ibericos",
    name: "Salchichón Ibérico de Bellota",
    unit: "Sarta 250 g",
    description: "Pimienta negra · textura firme",
    price_cents: 950,
    image:
      "https://images.unsplash.com/photo-1599909533730-08f1f23a2dbe?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "queso-oveja-200g",
    category: "ibericos",
    name: "Queso Puro de Oveja",
    unit: "Cuña 200 g",
    description: "Curado en cueva · sabor intenso",
    price_cents: 800,
    image:
      "https://images.unsplash.com/photo-1626957341926-98752fc2ba90?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "queso-cabra-200g",
    category: "ibericos",
    name: "Queso de Cabra Curado",
    unit: "Cuña 200 g",
    description: "Suave en boca · curación 4 meses",
    price_cents: 700,
    image:
      "https://images.unsplash.com/photo-1486297678162-eb2a19b0a32d?auto=format&fit=crop&w=1200&q=80",
  },

  // ===== TABLAS Y SURTIDOS =====
  {
    id: "tabla-serrana",
    category: "tablas",
    name: "Tabla Serrana",
    unit: "Jamón + queso + lomito",
    description: "Para 2-3 personas · selección del chef",
    price_cents: 4200,
    image:
      "https://images.unsplash.com/photo-1606925207923-c5a4a9d68f06?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "surtido-ibericos-300g",
    category: "tablas",
    name: "Surtido de Ibéricos",
    unit: "Bandeja 300 g",
    description: "Jamón + chorizo + salchichón + lomo",
    price_cents: 2800,
    image:
      "https://images.unsplash.com/photo-1608897013039-887f21d8c804?auto=format&fit=crop&w=1200&q=80",
  },

  // ===== PLATOS AL VACÍO =====
  {
    id: "carrillera-vacio",
    category: "platos",
    name: "Carrillera Ibérica en Salsa",
    unit: "Al vacío 400 g",
    description: "Receta de la casa · solo calentar",
    price_cents: 1500,
    image:
      "https://customer-assets.emergentagent.com/job_corte-tradicional/artifacts/30goqe4k_4187bb32-94d5-4add-b338-415436ab4b55.jpg",
  },
  {
    id: "croquetas-jamon-12",
    category: "platos",
    name: "Croquetas Caseras de Jamón",
    unit: "12 unidades",
    description: "Crujientes por fuera, cremosas dentro",
    price_cents: 1000,
    image:
      "https://images.unsplash.com/photo-1604908554049-01361b3f8d3f?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "salmorejo-500ml",
    category: "platos",
    name: "Salmorejo Casero",
    unit: "Tarro 500 ml",
    description: "Tomate rosa · receta tradicional",
    price_cents: 700,
    image:
      "https://images.unsplash.com/photo-1547592180-85f173990554?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "tortillitas-camaron-8",
    category: "platos",
    name: "Tortillitas de Camarón",
    unit: "Pack 8 unidades",
    description: "Receta gaditana · listas para freír",
    price_cents: 900,
    image:
      "https://images.unsplash.com/photo-1625938145744-533e82c2e8f4?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "patatas-sanluquena",
    category: "platos",
    name: "Patatas Aliñadas Sanluqueñas",
    unit: "Tarrina 400 g",
    description: "Cebolla, atún, perejil y aceite virgen",
    price_cents: 650,
    image:
      "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?auto=format&fit=crop&w=1200&q=80",
  },

  // ===== PESCADOS Y CONSERVAS =====
  {
    id: "ventresca-atun-200g",
    category: "pescados",
    name: "Ventresca de Atún Rojo Almadraba",
    unit: "200 g",
    description: "Lujo gastronómico · sabor único",
    price_cents: 2800,
    image:
      "https://customer-assets.emergentagent.com/job_corte-tradicional/artifacts/nlp4fm74_874fef21-90cc-4571-a0f3-8804577660c5.jpg",
  },
  {
    id: "bacalao-aceite-250g",
    category: "pescados",
    name: "Bacalao en Aceite",
    unit: "Tarro 250 g",
    description: "Lomos selectos en aceite de oliva virgen",
    price_cents: 1200,
    image:
      "https://customer-assets.emergentagent.com/job_corte-tradicional/artifacts/vs5ybj4z_9491d4af-edd2-4f16-9d06-3fd2d9e1a1b6.jpg",
  },
  {
    id: "mojama-atun-100g",
    category: "pescados",
    name: "Mojama de Atún",
    unit: "100 g",
    description: "Salada y secada al sol · aperitivo gourmet",
    price_cents: 900,
    image:
      "https://images.unsplash.com/photo-1559717865-a99cac1c95d8?auto=format&fit=crop&w=1200&q=80",
  },

  // ===== BODEGA =====
  {
    id: "vino-crianza-ribera",
    category: "bodega",
    name: "Vino Tinto Crianza Ribera del Duero",
    unit: "Botella 750 ml",
    description: "Acompañante perfecto de los ibéricos",
    price_cents: 1400,
    image:
      "https://images.unsplash.com/photo-1547595628-c61a29f496f0?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "manzanilla-sanlucar",
    category: "bodega",
    name: "Manzanilla de Sanlúcar",
    unit: "Botella 750 ml",
    description: "Vino fino · ideal con pescaíto frito",
    price_cents: 950,
    image:
      "https://images.unsplash.com/photo-1568213816046-0ee1c42bd559?auto=format&fit=crop&w=1200&q=80",
  },
];

export const PRODUCT_CATEGORIES = [
  { id: "all", labelKey: "all" },
  { id: "ibericos", labelKey: "ibericos" },
  { id: "tablas", labelKey: "tablas" },
  { id: "platos", labelKey: "platos" },
  { id: "pescados", labelKey: "pescados" },
  { id: "bodega", labelKey: "bodega" },
];

export const getProductById = (id) => PRODUCTS.find((p) => p.id === id);
